// -----------------------------------------------------------------------------
// src/pages/Misc/BookingDialog.js (UPDATED - Mobile Safe)
// -----------------------------------------------------------------------------
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  useMediaQuery,
} from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';
import UnifiedOfferWizard from '../../PartnershipsDeliverablesBookings/unifiedbookingwizard';

// Constants for mobile bottom navigation (from AppShell)
const BOTTOM_NAV_HEIGHT = 86;
const MOBILE_SAFE_PADDING = 12;

/**
 * BookingDialog - For public/external partnership creation
 * 
 * PROPS:
 * - open: boolean - Dialog open state
 * - onClose: function - Close callback
 * - creator: object - Creator object
 * - isCelebrity: boolean - If true, don't auto-fill amounts
 * - onPartnershipCreated: function - Callback when partnership is created
 */
const BookingDialog = ({ 
  open, 
  onClose, 
  creator, 
  isCelebrity = false,
  onPartnershipCreated 
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleComplete = (data) => {
    onClose();
    onPartnershipCreated?.(data);
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth={false} 
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: { xs: 2.5, md: 2.5 },
          minHeight: isMobile ? 'auto' : '82vh',
          maxWidth: isMobile ? '100%' : '900px',
          width: isMobile ? '100%' : 'min(900px, calc(100vw - 72px))',
          m: isMobile ? 2 : 0,
          mb: isMobile ? `${BOTTOM_NAV_HEIGHT + MOBILE_SAFE_PADDING + 16}px` : 3,
          maxHeight: isMobile
            ? `calc(100vh - ${BOTTOM_NAV_HEIGHT + MOBILE_SAFE_PADDING + 32}px)`
            : '86vh',
          overflow: 'hidden',
          bgcolor: '#fbfaf8',
          boxShadow: '0 30px 90px rgba(17, 24, 39, 0.24)',
        }
      }}
    >
      <DialogTitle 
        sx={{ 
          display: 'flex', 
          justifyContent: 'flex-start', 
          alignItems: 'center',
          bgcolor: '#fbfaf8',
          color: '#1c1917',
          py: { xs: 1.4, md: 1.6 },
          px: { xs: 2, md: 1.8 },
          position: 'sticky',
          top: 0,
          zIndex: 2,
          borderBottom: 'none',
        }}
      >
        <Box sx={{ fontSize: { xs: '1.05rem', md: '1.2rem' }, fontWeight: 900, letterSpacing: '-0.02em' }}>
          Blitz
        </Box>
      </DialogTitle>
      
      <DialogContent 
        sx={{ 
          p: 0,
          bgcolor: '#fbfaf8',
          overflow: 'auto',
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-track': {
            background: alpha(theme.palette.divider, 0.05),
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-thumb': {
            background: alpha(theme.palette.divider, 0.2),
            borderRadius: '4px',
            '&:hover': {
              background: alpha(theme.palette.divider, 0.3),
            },
          },
        }}
      >
        <UnifiedOfferWizard
          creator={creator}
          isExternal={true}
          isCelebrity={isCelebrity}
          onComplete={handleComplete}
          onCancel={onClose}
          isInDialog={true}
        />
      </DialogContent>
    </Dialog>
  );
};

export default BookingDialog;
